import Header from "../Navigation/header";
import Footer from "../Navigation/footer";
import ScorecardHomeSubHeader from "./ScorecardHome/scorecardHomeSubHeader";
import "./scorecardFAQ.css";
import "../../index.css";

const faq = [
  {
    question: "What is the Wildfire Resilience Scorecard?",
    answer:
      "The Wildfire Resilience Scorecard is a new tool developed collaboratively by the ARISE-US Global Network, CrowdDoing and wildfire experts. UNDRR supports disaster risk reduction globally. ARISE builds community resilience through public-private-civic partnerships. CrowdDoing connects volunteers to crowdsource solutions.",
  },
  {
    question: "What does the 'Download' contain?",
    answer:
      "The download is a zip file which includes three files: Instructions, Spreadsheet, and PDF files.",
  },
  {
    question: "How can the Wildfire Resilience Scorecard help my community?",
    answer:
      "The scorecard enables your community to methodically assess its wildfire preparedness. By identifying vulnerabilities, you can create data-driven action plans to boost wildfire safety, drive collaboration, and make your community more resilient.",
  },
  {
    question: "Who is the scorecard designed for?",
    answer:
      "The scorecard is designed for use by local governments / municipalities, community groups, businesses, and residents. It provides a tool to bring together diverse stakeholders around wildfire resilience.",
  },
  {
    question: "What does the scorecard process involve?",
    answer:
      "Communities can use the scorecard framework and spreadsheet tool to self-assess their wildfire readiness across categories. This produces vulnerability scores and identifies areas for improvement. The process turns assessment into actionable strategies.",
  },
  {
    question: "How long does the scorecard take to complete?",
    answer:
      "The completion time for the Scorecard is flexible and depends on various factors, including the size of your geographical location, community, type of landscape(s), the number of participants, and any other complexities that may arise.",
  },
  {
    question: "Where can I access the Wildfire Resilience Scorecard?",
    answer: (
      <>
        The scorecard is available for free download{" "}
        <a
          href="https://www.preventionweb.net/publication/wildfire-resilience-scorecard"
          target="_blank"
          rel="noreferrer"
        >
          here
        </a>{" "}
        !
      </>
    ),
  },
  {
    question: "Do I need to answer every question?",
    answer:
      "No, you are not obligated to answer every question; however, we encourage you to address all questions relevant to your situation. It is advisable to at least review all the Essentials sections and carefully read the questions to ensure you have considered factors that may not have been contemplated previously. The Scorecard serves as a comprehensive framework designed to consider all aspects that may impact and enhance a community's safety, health, and collaboration.",
  },
  {
    question: "How can my municipality get involved?",
    answer:
      "Municipalities are invited to join a pilot program to test the scorecard and provide feedback before broader release.",
  },
  {
    question: "How can the scorecard help make communities more resilient?",
    answer:
      "By identifying wildfire vulnerabilities before a disaster, communities can take proactive, collaborative action to mitigate risks. Investing in resilience capacity ahead of time provides huge savings compared to recovery costs. The scorecard aims to accelerate this process.",
  },
  {
    question:
      "Where can I inquire for more information or get help completing the scorecard?",
    answer: (
      <>
        Email{" "}
        <a href="mailto:contact@preventwildfire.world">
          contact@preventwildfire.world
        </a>{" "}
        for details and feedback.
      </>
    ),
  },
  {
    question: "How do I interpret the Scorecard?",
    answer:
      "The Summary Scores sheet helps you compare various parameters/ essentials for wildfire prevention allowing you to identify areas where improvement is required. The chart offers visual comparison of the 10 essential parameters for holistic understanding of the current evaluation and better planning for disaster resilience.\n\nThe Scorecard may direct attention to issues that a community cannot immediately control – for example, utility-owned energy or water systems, or the stance of neighboring communities towards preparing for resilience. However, if those issues affect the disaster resilience of the community, they need to be planned for even if, in the short term, they cannot be corrected. In the longer term, they become subjects for discussions, negotiations, advocacy, lobbying and legislation and working through industry associations to bring about the necessary changes.",
  },
];

const ScorecardFAQ = () => {
  return (
    <>
      <ScorecardHomeSubHeader />
      <div className="scorecard-faq">
        <h2>Frequently Asked Questions (FAQ) </h2>
        {faq.map((QAset, index) => (
          <div key={index} className="qa-set">
            <p className="question">Q. {QAset.question}</p>
            <p className="answer">A. {QAset.answer}</p>
          </div>
        ))}
      </div>
    </>
  );
};

export default ScorecardFAQ;
